import LocContext from "./locContext";
import CryptoJS from 'crypto-js';

const LocState = (props) => {
    let userData = null;
    try {
        const cryptUserData = localStorage.getItem(process.env.REACT_APP_LOGIN_DATA_STORE);
        if (cryptUserData) {
            const bytes = CryptoJS.AES.decrypt(cryptUserData, process.env.REACT_APP_LOGIN_SEC);
            const decrypted = bytes.toString(CryptoJS.enc.Utf8);

            if (decrypted) {
                userData = JSON.parse(decrypted);
            }
        }
    } catch (err) {
        console.error("Failed to decrypt or parse user data:", err);
    }

    return (
        <LocContext.Provider value={{ userData }}>
            {props.children}
        </LocContext.Provider>
    )
}

export default LocState;